import LegalPage from './LegalPage';

const Cookies = () => {
  return <LegalPage file="cookies" title="Cookie-Richtlinie" />;
};

export default Cookies;
